import MeaPage from "../../../components/MeaPage";
import { useEffect, useMemo, useRef, useState } from "react";
import SessionsListComponent from "./components/SessionsListComponent";
import { useLoaderData, useParams } from "react-router-dom";
import { SelectButton } from "primereact/selectbutton";
import { ToFormatedShortISODate } from "../../../utils/dates";
import { PERMISSION_TRAINING_SESSIONS } from "../../../permissions";
import MeaPermissionGuard from "../../../components/MeaPermissionGuard";

const SessionsListPage = () => {
  //
  const { training } = useLoaderData();
  const { schoolId, trainingId } = useParams();
  const listRef = useRef();
  const [selectedMonth, setSelectedMonth] = useState(null);

  const monthOptions = useMemo(() => {
    const startDate = training?.start_courses_date ? new Date(training.start_courses_date) : new Date();
    const endDate = training?.end_courses_date ? new Date(training.end_courses_date) : new Date();
    const months = [];
    const loopDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1);

    while (loopDate <= endDate) {
      const year = loopDate.getFullYear();
      const month = loopDate.getMonth();
      const firstDay = new Date(year, month, 1);
      const lastDay = new Date(year, month + 1, 0);

      months.push({
        label: firstDay.toLocaleDateString("fr-FR", { month: "long", year: "numeric" }),
        value: `${year}-${String(month + 1).padStart(2, "0")}`,
        start_date: ToFormatedShortISODate(firstDay),
        end_date: ToFormatedShortISODate(lastDay),
      });

      loopDate.setMonth(loopDate.getMonth() + 1);
    }

    if (months.length === 0) {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth();
      const firstDay = new Date(year, month, 1);
      const lastDay = new Date(year, month + 1, 0);

      months.push({
        label: firstDay.toLocaleDateString("fr-FR", { month: "long", year: "numeric" }),
        value: `${year}-${String(month + 1).padStart(2, "0")}`,
        start_date: ToFormatedShortISODate(firstDay),
        end_date: ToFormatedShortISODate(lastDay),
      });
    }

    return months;
  }, [training?.start_courses_date, training?.end_courses_date]);

  const currentMonthValue = useMemo(() => {
    const currentDate = new Date();
    return `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, "0")}`;
  }, []);

  const selectedMonthData = monthOptions.find((month) => month.value === selectedMonth) || monthOptions[0];

  useEffect(() => {
    if (!monthOptions[0]) {
      return;
    }

    if (!selectedMonth) {
      const defaultMonth =
        monthOptions.find((month) => month.value === currentMonthValue) || monthOptions[0];
      setSelectedMonth(defaultMonth.value);
      return;
    }

    const selectedMonthStillAvailable = monthOptions.some((month) => month.value === selectedMonth);
    if (!selectedMonthStillAvailable) {
      setSelectedMonth(monthOptions[0].value);
    }
  }, [currentMonthValue, monthOptions, selectedMonth]);
  //
  return (
    <MeaPermissionGuard
      permission={PERMISSION_TRAINING_SESSIONS.LIST}
      fallbackTo={`/school/${schoolId}/admin/trainings/${trainingId}/info`}
    >
      <MeaPage
        title="Liste des séances de cours"
        subtitle="Gérer l'ensemble des séances de cours dans cette formation"
      >
        <div className="mb-3">
          <SelectButton
            value={selectedMonth || selectedMonthData?.value}
            options={monthOptions}
            optionLabel="label"
            optionValue="value"
            onChange={(e) => setSelectedMonth(e.value)}
            className="w-full flex-wrap"
          />
        </div>
        <SessionsListComponent
          key={selectedMonthData?.value || "default"}
          ref={listRef}
          schoolId={schoolId}
          trainingId={trainingId}
          showAddButton={true}
          showFilterButton={true}
          filter={{
            start_date: selectedMonthData?.start_date,
            end_date: selectedMonthData?.end_date,
          }}
          showAllSessions={true}
        />
      </MeaPage>
    </MeaPermissionGuard>
  );
};
export default SessionsListPage;
